// @flow
import { useCallback, useContext } from 'react';
import { useSelector } from 'react-redux';
import { formatPrice } from '@src/utils/general';

import { BandStateContext } from '@contexts/band';

import * as routes from '@src/app_routes/settings';

import css from '@styles/productDetail/matchingSettings';

import type { TMatchingSetting } from '@types/setting';

function MatchingSettings() {
  const { band } = useContext(BandStateContext);
  const recentlyViewedSettings = useSelector(
    state => state.recentlyViewedSettings
  );

  const matchingSettings = [...(band.matching_settings || [])];

  matchingSettings.sort((a, b) => {
    const recentlyViewedAIndex = recentlyViewedSettings.findIndex(
      el => el.vendor_sku === a.vendor_sku
    );

    const recentlyViewedBIndex = recentlyViewedSettings.findIndex(
      el => el.vendor_sku === b.vendor_sku
    );

    if (recentlyViewedAIndex >= 0 && recentlyViewedBIndex >= 0) {
      return recentlyViewedAIndex - recentlyViewedBIndex;
    } else if (recentlyViewedAIndex >= 0) {
      return -1;
    } else if (recentlyViewedBIndex >= 0) {
      return 1;
    } else {
      return 0;
    }
  });

  const navigateToDetail = useCallback(
    (sku: string) => {
      const item = matchingSettings.find(item => item.vendor_sku === sku);

      if (window) window.location = routes.detailPath(item);
    },
    [matchingSettings]
  );

  if (matchingSettings.length === 0) return null;

  return (
    <div>
      <h2 className={css.title}>Matching Settings</h2>
      <div className={css.listContainer}>
        {matchingSettings.map((item, i) => {
          return (
            <div
              key={i}
              className={css.listItem}
              onClick={() => navigateToDetail(item.vendor_sku)}
            >
              <div className={css.imageSquareContainer}>
                <div className={css.imageBox}>
                  <img
                    className={css.image}
                    src={item.image.standard}
                    alt='Setting preview'
                  />
                </div>
              </div>
              <div className={css.description}>{item.description}</div>
              <div className={css.price}>{formatPrice(item.retail_price)}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default MatchingSettings;
